import styled from 'styled-components';
import { Icon, IIconProps } from 'ui-toolkit';

interface IRotateIcon extends IIconProps {
  isRotated: boolean;
}

export const RotateIcon = styled(Icon)<IRotateIcon>`
  transform: ${(props) => (props.isRotated ? 'rotate(0deg)' : 'rotate(180deg)')};
`;
